import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      paramsData: {
        page: 1,
        page_size: 10
      },
      tableData: [],
      total: 0
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.devisionId = data.id;

                  _this.getUserList(1);
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    getUserList: function getUserList(page) {
      var _this2 = this;

      this.paramsData.page = page;
      this.$api.divisionStudents(_objectSpread({
        id: this.devisionId
      }, this.paramsData)).then(function (res) {
        if (res.code == 200) {
          _this2.tableData = res.data.data;
          _this2.total = res.data.total;
        }
      });
    }
  }
};